import { render } from "./Atencion_Referencia.vue?vue&type=template&id=a32bb18e&scoped=true"
import script from "./Atencion_Referencia.vue?vue&type=script&lang=js"
export * from "./Atencion_Referencia.vue?vue&type=script&lang=js"

import "@/assets/css/microfono.css?vue&type=style&index=0&id=a32bb18e&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=a32bb18e&scoped=true&lang=css"
import "./Atencion_Referencia.vue?vue&type=style&index=2&id=a32bb18e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32bb18e"]])

export default __exports__